import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './QKeyBinder.scss';
import { _className, ComponentSync, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
/**
 * encapsulate the children with a container that traps focus tabbing
 */
export class QKeyBinder extends ComponentSync {
    firstTabBinder = React.createRef();
    lastTabBinder = React.createRef();
    deriveStateFromProps(nextProps) {
        return {};
    }
    renderFirstTabBounder() {
        return _jsx("div", { tabIndex: 0, ref: this.firstTabBinder, className: 'q-key-binder__tab-binder', role: 'tab-binder', onKeyDown: (e) => {
                if (e.key === 'Tab' && e.shiftKey) {
                    stopPropagation(e);
                    return this.lastTabBinder.current.focus();
                }
            } });
    }
    renderLastTabBounder() {
        return _jsx("div", { tabIndex: 0, ref: this.lastTabBinder, className: 'q-key-binder__tab-binder', role: 'tab-binder', onKeyDown: (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    stopPropagation(e);
                    return this.firstTabBinder.current.focus();
                }
            } });
    }
    renderChildren() {
        if (!this.props.children)
            return '';
        return React.Children.map(this.props.children, (child) => {
            return _jsx("div", { className: 'q-key-binder__child-wrapper', children: child });
        });
    }
    render() {
        const className = _className('q-key-binder', this.props.className);
        return _jsxs("div", { className: className, children: [this.renderFirstTabBounder(), this.renderChildren(), this.renderLastTabBounder()] });
    }
}
//# sourceMappingURL=QKeyBinder.js.map